import {
  get,
  post,
  del,
} from './http';

export function listFavorites(context) {
  return get(context, 'favorite/list');
}

export function addFavorite(data, context) {
  return post(context, 'favorite', data);
}

export function deleteFavorite(id, context) {
  return del(context, `favorite/${id}`);
}
